import { render, staticRenderFns } from "./TripHandlingRequestPopup.vue?vue&type=template&id=581bb958&"
import script from "./TripHandlingRequestPopup.vue?vue&type=script&lang=js&"
export * from "./TripHandlingRequestPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports